const reqSorter = (a, b) => a.reqOrder - b.reqOrder;
const resSorter = (a, b) => a.resOrder - b.resOrder;
const errSorter = (a, b) => a.errOrder - b.errOrder;
export default class FeatureManager {
    constructor() {
        this.reqInterceptorList = [];
        this.resInterceptorList = [];
        this.errInterceptorList = [];
    }
    async exec(list, input, catchError = false) {
        let prev = input;
        for (let i = 0; i < list.length; i++) {
            const func = list[i];
            try {
                prev = await func(prev);
            }
            catch (err) {
                if (catchError) {
                    prev = err;
                    continue;
                }
                throw err;
            }
        }
        return prev;
    }
    push(feature) {
        const { reqInterceptorList, resInterceptorList, errInterceptorList } = this;
        if (feature.reqOrder !== undefined) {
            reqInterceptorList.push(feature);
            reqInterceptorList.sort(reqSorter);
        }
        else if (feature.resOrder !== undefined) {
            resInterceptorList.push(feature);
            resInterceptorList.sort(resSorter);
        }
        else if (feature.errOrder !== undefined) {
            errInterceptorList.push(feature);
            errInterceptorList.sort(errSorter);
        }
    }
    get reqInterceptor() {
        return async (config) => {
            try {
                return await this.exec(this.reqInterceptorList.map((item) => item.reqInterceptor), config);
            }
            catch (err) {
                // 标记为是被手动取消的
                err.__CANCEL__ = true;
                throw await this.errInterceptor(err);
            }
        };
    }
    get resInterceptor() {
        return async (response) => {
            try {
                return await this.exec(this.resInterceptorList.map((item) => item.resInterceptor), response);
            }
            catch (err) {
                throw await this.errInterceptor(err);
            }
        };
    }
    get errInterceptor() {
        return async (error) => {
            throw await this.exec(this.errInterceptorList.map((item) => item.errInterceptor), error, true);
        };
    }
}
